const secMs = 1000;
const minMs = secMs * 60;
const hourMs = minMs * 60;
const dayMs = hourMs * 24;

export function timeToParts(time: number, partCount: number) {
  const parts = [
    { div: dayMs, suffix: 'd' },
    { div: hourMs, suffix: 'h' },
    { div: minMs, suffix: 'm' },
    { div: secMs, suffix: 's' },
  ];
  let remainder = time;
  let currentPartCount = 0;
  let result = '';
  parts.forEach((part) => {
    const value = Math.floor(remainder / part.div);
    if (value > 0 && currentPartCount < (partCount || 2)) {
      result += `${value}${part.suffix} `;
      remainder = remainder - value * part.div;
      currentPartCount += 1;
    }
  });
  // Make sure there is ms if nothing else
  if (currentPartCount === 0) {
    result = `n/a`;
  }

  return result;
}
